<template>
	<div class="game-space">
		<div class="game-space-inner">
			<transition
				:name="transitionName" mode="out-in"
				@before-enter="beforeEnterHandler"
				@after-enter="afterEnterHandler"
			>
				<router-view class="game-space-router" name="gameSpace" />
			</transition>
		</div>
		<transition name="fade">
			<ModalOverlay class="fast-fade fade-enter-active" v-if="activeModal" />
		</transition>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import ModalOverlay from '@/components/partials/ModalOverlay';

export default {
	name: 'GameSpace',
	components: {
		ModalOverlay,
	},
	computed: {
		...mapState({
			activeModal: (state) => state.global.modal.active,
		}),
	},
	data() {
		return {
			transitionName: "",
			isTransitioning: false,
		};
	},
	methods: {
		beforeEnterHandler() {
			this.isTransitioning = true;
		},
		afterEnterHandler() {
			this.isTransitioning = false;
		},
	},
	watch: {
		$route(to) {
			this.transitionName = to.meta?.transition ? to.meta.transition : "fade";
		},
	},
};
</script>

<style lang="scss" scoped>
	.game-space {
		@include gradient-background;
		flex-grow: 1;
		height: 100%;
		width: 100%;
		user-select: none;
	}

	.game-space-inner {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.game-space-router { height: 100%; }
</style>
